import { render } from "./PageProduct.vue?vue&type=template&id=a95b2c00"
import script from "./PageProduct.vue?vue&type=script&lang=js"
export * from "./PageProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__